const companysizes = [
    { label: "Small", value: "Small", targetType: "Size" },
    { label: "Mid-Market", value: "Mid-Market", targetType: "Size" },
    { label: "Enterprise", value: "Enterprise", targetType: "Size" }
];

export default companysizes;
